
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <div v-if="form.filters.analitico">
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.origemAnalitico"
                            label="Origem"
                            dense
                            outlined
                            :item-text="(v) => v.nome.toUpperCase()"
                            item-value="id"
                            :items="form.lists.origens"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            v-model="form.filters.setorAnalitico"
                            :items="form.lists.listaSetores"
                            label="Setor"
                            item-text="nome"
                            item-value="id"
                            outlined
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete
                            v-model="form.filters.funcaoAnalitico"
                            label="Função"
                            outlined
                            dense
                            :items="form.lists.listaFuncoes"
                            item-text="nome"
                            item-value="id"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            label="Formação"
                            v-model="form.filters.formacaoAnalitico"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioAnalitico"
                        removeIcon
                        outlined
                        dense
                  ></sigfoco-date-picker>
                  <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFimAnalitico"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                  ></sigfoco-date-picker>
                  <sigfoco-select-ativo
                        :cols="3"
                        v-model="form.filters.situacao"
                        labelType="Situação"
                    ></sigfoco-select-ativo>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
            </div>
            <div v-else>
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="3">
                        <v-autocomplete
                            v-model="form.filters.setorSintetico"
                            :items="form.lists.listaSetores"
                            label="Setor"
                            item-text="nome"
                            item-value="id"
                            outlined
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete
                            v-model="form.filters.funcaoSintetico"
                            label="Função"
                            outlined
                            dense
                            :items="form.lists.listaFuncoes"
                            item-text="nome"
                            item-value="id"
                        />
                    </v-col>
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioSintetico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimSintetico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
            </div>
            <div class="text-center">
                <v-col cols="12">
                    <sigfoco-tooltip
                        text="Buscar"
                        icon="mdi-magnify"
                        @click="buscarRelatorios"
                    ></sigfoco-tooltip>
                    <sigfoco-tooltip
                        text="Limpar"
                        icon="mdi-eraser"
                        @click="resetForm"
                    ></sigfoco-tooltip>
                </v-col>
            </div>
        </v-form>
        <v-data-table
          v-if="form.mostrarAnalitico"
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorioAnalitico"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          :expanded.sync="expanded"
          show-expand
          item-key="formacaoId"
        >
          <template v-slot:[`item.origem`]="{ item }">
            {{ item.origem }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
              <td class="setor" :colspan="headers.length">
                    <v-chip-group active-class="primary--text" column>
                        <v-chip 
                            class="chip-permissao" 
                            v-for="(setor,  i) in item.setores" 
                            :key="i"
                        >
                            {{ setor.nome }}
                        </v-chip>
                    </v-chip-group>
                </td>
          </template>
          <template v-slot:[`item.funcaoAnalitico`]="{ item }">
            {{ item.funcaoAnalitico }}
          </template>
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.situacao === 'Ativo'"></sigfoco-label-ativo-inativo>
          </template>
        </v-data-table>
        <v-data-table
            v-else
            class="mt-5 printable"
            :headers="getFilteredHeader(headersSintetico)"
            :items="form.lists.listRelatorioSintetico"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
            :expanded.sync="expanded"
            show-expand
            item-key="funcaoId"
        >
            <template v-slot:expanded-item="{ headers, item }">
              <td class="setor" :colspan="headers.length">
                    <v-chip-group active-class="primary--text" column>
                        <v-chip 
                            class="chip-permissao" 
                            v-for="(setor,  i) in item.setores" 
                            :key="i"
                        >
                            {{ setor.nome }}
                        </v-chip>
                    </v-chip-group>
                </td>
          </template>
            <template v-slot:[`item.setorSintetico`]="{ item }">
            {{ item.setorSintetico }}
            </template>
            <template v-slot:[`item.funcaoSintetico`]="{ item }">
            {{ item.funcaoSintetico }}
            </template>
            <template v-slot:[`item.qtdFormacoes`]="{ item }">
            {{ item.qtdFormacoes }}
            </template>
            <template v-slot:[`item.qtdPrevistas`]="{ item }">
            {{ item.qtdPrevistas }}
            </template>
            <template v-slot:[`item.qtdPresentes`]="{ item }">
            {{ item.qtdPresentes }}
            </template>
            <template v-slot:[`item.qtdAusentes`]="{ item }">
            {{ item.qtdAusentes }}
            </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorioAnalitico.length > 0 || form.lists.listRelatorioSintetico.length > 0"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import RelatorioSinteticoAnalitico from "services/relatorios-sintetico-analiticos/solicitacao-formacao.service";
import ManterSetorService from "~/services/manter-setor.service";
import FormacaoService from "~/services/manter-formacao.service";   
import ManterFuncoesService from "~/services/manter-funcao.service"; 
// import OrigemEnum from '~/commons/enums/origem.enum'; 
export default {
    name: "RelatorioSolicitacaoFormacaoPorEscola",
    mixins: [pageLoadingMixin, RelatorioSinteticoAnalitico, ManterSetorService, FormacaoService, ManterFuncoesService],
    data: () => ({
    onReport: false,
    expanded: [],
    form: {
        filters: {
            analitico: true,
            // analitico
            origemAnalitico: null,
            setorAnalitico: null,
            funcaoAnalitico: null,
            formacaoAnalitico: null,
            dataInicioAnalitico: null,
            dataFimAnalitico: null,
            situacao: null,
            
            // sintetico
            setorSintetico: null,
            funcaoSintetico: null,
            dataInicioSintetico: null,
            dataFimSintetico: null,
        },
        lists: {
            listRelatorios: [],
            listRelatorioAnalitico: [],
            listRelatorioSintetico: [],
            origens: [],
            listaSetores: [],
            listaFuncoes: [],
        },
        itemsPerPage: 10,
        geradorRelatorio: null,
        horaDaGeracao: null,
        totalSolicitacaoFormacao: 0,
        mostrarAnalitico: true,
    },
    headersAnalitico: [
        { text: "Origem", align: "center", value: "origem" },
        // { text: "Setor", align: "center", value: "setor" },
        { text: "Setor", align: "center", value: "data-table-expand", onlyView: true },
        { text: "Setor", align: "center", value: "data-table-expand", onlyReport: true },
        { text: "Função", align: "center", value: "funcao" },
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Situação", align: "center", value: "situacao" },
    ],
    headersSintetico: [
        { text: "Setor", align: "center", value: "data-table-expand", onlyView: true },
        { text: "Setor", align: "center", value: "data-table-expand", onlyReport: true },
        { text: "Função", align: "center", value: "funcao" },
        { text: "Quantidade de Formações", align: "center", value: "qtdFormacoes" },
        { text: "Quantidade Prevista de Participantes", align: "center", value: "qtdPrevistas" },
        { text: "Quantidade de Participantes Presentes", align: "center", value: "qtdPresentes" },
        { text: "Quantidade de Participantes Ausentes", align: "center", value: "qtdAusentes" },
    ],
    }),
    watch: {
        "form.filters.analitico"(novoValor) {
            this.form.mostrarAnalitico = novoValor;
            this.resetForm();
        }
    },

    computed: {
        isAnalitico() {
            return this.form.filters.analitico;
        },
    },
    methods: {
    getFilteredHeader(headers) {
        return headers.filter(header => {
        if (header.onlyView) return !this.onReport;
        if (header.onlyReport) return this.onReport;
        return true;
        });
    },
    buscarRelatorios() {
        const isValid = this.validarDatas();
        if (!isValid) return;
        const preparedRequest = this.prepararRequisicao();
            const buscarRelatorio = (request) => {
            return this.$obterRelatorioAnaliticoFormacoesPorFuncao(request);
            };
            buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(
            ({ data }) => {
                this.form.mostrarAnalitico = this.isAnalitico;
                this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
                this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
                this.isAnalitico ? this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico : this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico; 
            }
        );
    },
    validarDatas() {
        const { dataInicioAnalitico, dataFimAnalitico, dataInicioSintetico, dataFimSintetico } = this.form.filters;
        const msgData = "A Data Início precisa ser anterior ou igual à Data Final";
        if (dataInicioAnalitico && dataFimAnalitico) {
            if (new Date(dataInicioAnalitico) > new Date(dataFimAnalitico)) {
                this.$notifyWarning(msgData);
                return false;
            }
        }
        if (dataInicioSintetico && dataFimSintetico) {
            if (new Date(dataInicioSintetico) > new Date(dataFimSintetico)) {
                this.$notifyWarning(msgData);
                return false;
            }
        }

        return true;
    },
    async baixarCSVRelatorio() { 
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
            const { data } = await (this.$obterRelatorioAnaliticoCSVFormacoesPorFuncao(this.$montarParamsFilters(preparedRequest))
            );
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeDeFormaçãoPorFunção`);
            this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
            this.hidePageLoading();
        }
    },

    async baixarRelatorioPdf() {
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
            const { data } = await (this.$obterRelatorioAnaliticoPDFFormacoesPorFuncao(this.$montarParamsFilters(preparedRequest)));

            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeFormaçõesPorFunção.pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
            this.hidePageLoading();
        }
    },

    prepararRequisicao() {
        if (this.isAnalitico) {
        return {
            origemId: this.form.filters.origemAnalitico,
            setorId: this.form.filters.setorAnalitico,
            funcaoId: this.form.filters.funcaoAnalitico,
            formacao: this.form.filters.formacaoAnalitico,
            dataInicio: this.form.filters.dataInicioAnalitico,
            dataFim: this.form.filters.dataFimAnalitico,
            isAnalitico: this.isAnalitico,
            situacao: this.form.filters.situacao,
        };
        } else {
        return {
            setorId: this.form.filters.setorSintetico,
            funcaoId: this.form.filters.funcaoSintetico,
            dataInicio: this.form.filters.dataInicioSintetico,
            dataFim: this.form.filters.dataFimSintetico,
            isAnalitico: this.isAnalitico,
        };
        }
    },
    resetForm() {
        this.form.filters.dataInicioAnalitico = null;
        this.form.filters.dataFimAnalitico = null;
        this.form.filters.dataInicioSintetico = null;
        this.form.filters.dataFimSintetico = null;

        this.$nextTick(() => {
        this.$set(this.form.filters, 'dataInicioAnalitico', null);
        this.$set(this.form.filters, 'dataFimAnalitico', null);
        this.$set(this.form.filters, 'dataInicioSintetico', null);
        this.$set(this.form.filters, 'dataFimSintetico', null);
        });
        // Analitico 
        this.form.filters.origemAnalitico = null;
        this.form.filters.setorAnalitico = null;
        this.form.filters.funcaoAnalitico = null;
        this.form.filters.formacaoAnalitico = null;
        this.form.filters.situacao = null;
        // Sintetico
        this.form.filters.setorSintetico = null;
        this.form.filters.funcaoSintetico = null;
        this.form.lists.listRelatorioAnalitico = [];
        this.form.lists.listRelatorioSintetico = [];
        this.expanded = [];
    },
    buscarSetores() {
      this.$buscarSetores().then(
        ({ data }) => this.form.lists.listaSetores = data.itens
      )
    },
    },
    mounted() {
        this.$buscarOrigens({ params: {apenasAtribuiveis: false} }).then(
            ({ data }) => this.form.lists.origens = data.itens
        );
        this.buscarSetores();
        this.$buscarFuncoes({origem: null}).then(({ data }) => {
            this.form.lists.listaFuncoes = data.itens.filter(funcao => funcao?.ativo);
        });
    }
};
</script>
<style scoped>
.setoresClass {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.setor {
  padding-right: 0.5em;
}
</style>